// extracted by mini-css-extract-plugin
export var container = "_cw-0";
export var infoIcon = "_cw-2";
export var titleRowCol = "_cw-1";